import { usePossibleOtherSiteFor } from "../api";

// The amber "check which site this is for" badge, shared so the Files tab's
// multi-site and possibly-another-site warnings read as one family.
export const SiteWarningBadge = ({
  label,
  title,
}: {
  label: string;
  title: string;
}): JSX.Element => (
  <span
    title={title}
    style={{
      display: "inline-block",
      padding: "1px 6px",
      marginLeft: 6,
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 500,
      background: "#fef3c7",
      color: "#92400e",
      border: "1px solid #fcd34d",
      // A long site label wraps inside the chip rather than squeezing the file name.
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      maxWidth: "100%",
    }}
  >
    ⚠ {label}
  </span>
);

// The wrong-site gate's below-the-bar suspicion for one upload, from the Files
// tab's list poll. The BE decides which files carry it (the same helper labels
// them for agents); this only words it.
export const PossibleOtherSiteBadge = ({
  uploadId,
}: {
  uploadId: string | null | undefined;
}): JSX.Element | null => {
  const flag = usePossibleOtherSiteFor(uploadId);
  if (!flag) return null;
  const site = flag.other_site;
  const label = flag.also_covers_this_site
    ? `Also covers another site${site ? ` (${site})` : ""}`
    : `Possibly another site's${site ? ` (${site})` : ""}`;
  const claim = flag.also_covers_this_site
    ? `also covers ${site ?? "another site"}`
    : `is probably about ${site ?? "another site"}, not this one`;
  const why = flag.rationale ? ` ${flag.rationale.replace(/[.\s]+$/, "")}.` : "";
  return (
    <SiteWarningBadge
      label={label}
      title={
        `An automated check thinks this file ${claim} (${flag.confidence} confidence).${why} ` +
        "It still counts towards this project, so check any value from it belongs to THIS site."
      }
    />
  );
};
